export default __webpack_public_path__ + "assets/media/win.545aefa8.mp3";